var map = {
	"./hp.svg": 281,
	"./print-os.svg": 282
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 584;



//////////////////
// WEBPACK FOOTER
// ./images ../~/html-loader!\.svg$
// module id = 584
// module chunks = 0